module.exports = __webpack_public_path__ + "img/D.57cdf6e.webp";